import Editor from './Editor';

export default Editor;



// WEBPACK FOOTER //
// ./src/components/Editor/index.ts